import { Alert, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getOrderInfo } from '../actions/orders';
import { BiasTable } from '../components/orderTracking/BiasTable';
import { OrderHeader } from '../components/orderTracking/OrderHeader';
import { diffDays, formatDateMX } from '../helpers/hours';
import {
	adminAreas,
	columnStyle,
	formatterCurrency,
	whichDivison,
	whichStatus,
	whichStatusColor,
	whichTypeOfPacking,
} from '../helpers/utils';

export const diffDaysOrder = (entry_date, delivery_date) =>
	diffDays(formatDateMX(entry_date), formatDateMX(delivery_date)) || 30;

export const OrderTracking = () => {
	// Get order id from params
	const { idOrder = null } = useParams();

	// States
	const [order, setOrder] = useState(null);
	const [showHeader, setShowHeader] = useState(true);

	// User
	const { user } = useSelector((state) => state);

	const isAdminView = () => {
		return (
			user?.user_type?.name === 'Operador' &&
			!adminAreas.includes(user?.area?.name)
		);
	};

	const formatOrder = (data) => ({
		...data,
		status: {
			key: data.status,
			name: whichStatus(data.status),
			color: whichStatusColor(data.status),
		},
		entry_date: formatDateMX(data.entry_date),
		delivery_date: formatDateMX(data.delivery_date),
		delivery_forecast: formatDateMX(data.delivery_forecast),
		client: data.client_id,
		created_by: {
			...data.created_by,
			fullname: `${data.created_by.first_name} ${
				data.created_by.last_name.split(' ')[0]
			}`,
		},
		type_of_packing: whichTypeOfPacking(data.type_of_packing),
		division: whichDivison(data.division),
		amount: {
			number: data.amount,
			formatted: isAdminView() ? '$ ----' : money(data.amount),
			withoutIVA: isAdminView() ? '$ ----' : money(data.amount / 1.16),
		},
		original_order: data,
		diff_days: diffDaysOrder(data.entry_date, data.delivery_date),
	});

	useEffect(() => {
		getData();
	}, [idOrder]);

	const getData = () => {
		// Get order info from DB
		getOrderInfo(idOrder).then(({ data }) => {
			setOrder(formatOrder(data));
		});
	};

	// Total amount
	const [totalAmount, setTotalAmount] = useState(0);

	return (
		<div style={{ padding: '25px' }}>
			{order ? (
				<>
					{/* Order header */}
					{showHeader && (
						<>
							<OrderHeader
								order={order}
								refreshOrder={getData}
								totalAmount={totalAmount}
							/>
							<hr />
						</>
					)}

					<BiasTable
						order={order}
						idOrder={idOrder}
						refreshOrder={getData}
						header={{ showHeader, setShowHeader }}
						totalAmount={totalAmount}
						setTotalAmount={setTotalAmount}
					/>
				</>
			) : (
				<div style={{ padding: '40px' }}>
					<Alert severity='warning'>
						No existe la información solicitada.
					</Alert>
				</div>
			)}
		</div>
	);
};

const money = (amount) => `${formatterCurrency(amount)}`;

export const Text = ({ variant, text }) => (
	<Typography variant={variant} gutterBottom>
		{text}
	</Typography>
);

export const Text2 = ({
	title,
	text,
	var1 = 'p',
	var2 = 'h4',
	color = 'black',
	bold = false,
}) => (
	<div style={{ ...columnStyle, color }}>
		<Typography variant={var1}>{title}</Typography>
		<Typography variant={var2}>{bold ? <b>{text}</b> : text}</Typography>
	</div>
);

export const TextForm = ({ label, value, setChange }) => (
	<TextField
		required
		style={{ width: '80%' }}
		label={label}
		value={value}
		onChange={({ target }) => setChange(target.value)}
	/>
);

export const stackStyle = {
	border: '1px solid white',
	// padding: '20px 20px 0 0',
	margin: '0 0 10px 0',
	width: '100%',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	justifyConten: 'space-between',
};

export const labelStyle = { width: '90%', margin: '10px 0' };
